/**
 *  @class
 *  @function Timeline
 */

if (!customElements.get('time-line')) {
	class Timeline extends HTMLElement {
		constructor() {
			super();
			this.id = this.dataset.id;
			this.scroller = this.querySelector('.timeline--scroll-container');
			this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
			this.scrollSet = false;
			this.items = this.querySelectorAll('.timeline--slide');
			this.labels = this.querySelectorAll('.timeline--scroll-pagination li');

			if (this.animations_enabled) {
				this.scrollSet = gsap.quickSetter('#time-line-progress-' + this.id, "scaleX");
			}
		}
		connectedCallback() {
			const _this = this;
			if (this.animations_enabled) {
				_this.scroller.addEventListener('scroll', () => this.onScroll());
			}

			_this.labels.forEach((item, i) => {
				_this.setLabelPosition(item);
			});
		}
		setLabelPosition(item) {
			let contentWidth = this.scroller.querySelector('.timeline--scroll-inner').offsetWidth,
				arr = Array.prototype.slice.call(this.labels),
				i = arr.indexOf(item),
				itemWidth = this.items[i].offsetWidth;

			item.style.flex = (itemWidth / contentWidth);
		}
		onScroll() {
			let scrollLeft = this.scroller.scrollLeft,
				scrollerWidth = this.scroller.offsetWidth,
				contentWidth = this.scroller.querySelector('.timeline--scroll-inner').offsetWidth,
				scrollPercent = (scrollLeft) / (contentWidth - scrollerWidth);

			this.scrollSet(scrollPercent);
		}
	}
	customElements.define('time-line', Timeline);
}

document.addEventListener('DOMContentLoaded', function() {
	const timeline = document.querySelector('time-line');
	const prevButton = document.querySelector('.timeline-nav-prev');
	const nextButton = document.querySelector('.timeline-nav-next');
	const container = timeline.querySelector('.timeline--scroll-container');
	const slides = Array.from(container.querySelectorAll('.timeline--slide'));
	const paginationItems = Array.from(document.querySelectorAll('.timeline--scroll-pagination li'));
	let currentIndex = 0;

	function scrollToSlide(index) {
	  if (index < 0) index = slides.length - 1;
	  if (index >= slides.length) index = 0;
	  currentIndex = index;
  
	  const slideWidth = slides[0].offsetWidth;
	  const containerWidth = container.offsetWidth;
	  const offset = slideWidth * currentIndex - (containerWidth - slideWidth) / 2;
  
	  container.scrollTo({
		left: offset,
		behavior: 'smooth'
	  });
  
	  updateActiveStates();
	}

	function updateActiveStates() {
	  slides.forEach((slide, i) => {
		slide.classList.toggle('active', i === currentIndex);
	  });
  
	  paginationItems.forEach((item, i) => {
		item.classList.toggle('active', i === currentIndex);
	  });
	}

	function onScroll() {
	  const slideWidth = slides[0].offsetWidth;
	  const scrollPosition = container.scrollLeft;
	  const index = Math.round(scrollPosition / slideWidth);
	  if (index !== currentIndex) {
		currentIndex = index;
		updateActiveStates();
	  }
	}

	prevButton.addEventListener('click', () => {
	  scrollToSlide(currentIndex - 1);
	});

	nextButton.addEventListener('click', () => {
	  scrollToSlide(currentIndex + 1);
	});

	container.addEventListener('scroll', onScroll);
	scrollToSlide(currentIndex);
});
  function isMobile() {
	return window.innerWidth <= 768;
  }

  function scrollToSlide(index) {
	if (index < 0) index = slides.length - 1;
	if (index >= slides.length) index = 0;
	currentIndex = index;

	const slideWidth = slides[0].offsetWidth;
	const containerWidth = container.offsetWidth;
	const offset = slideWidth * currentIndex - (containerWidth - slideWidth) / 2;

	container.scrollTo({
	  left: offset,
	  behavior: 'smooth'
	});

	updateActiveStates();

	if (isMobile()) {
	  centerActiveLabel();
	}
}

function centerActiveLabel() {
	const activeLabel = paginationItems[currentIndex].querySelector('.timeline--label');
	const labelParent = paginationItems[currentIndex];
	const parentWidth = labelParent.offsetWidth;
	const scrollContainer = document.querySelector('.timeline--scroll-pagination ul');
	const containerWidth = scrollContainer.offsetWidth;
  
	const offset = labelParent.offsetLeft - (containerWidth - parentWidth) / 2;
  
	scrollContainer.scrollTo({
		left: offset,
		behavior: 'smooth'
	});
}

function updateActiveStates() {
	slides.forEach((slide, i) => {
		slide.classList.toggle('active', i === currentIndex);
});
  
	paginationItems.forEach((item, i) => {
	  const isActive = i === currentIndex;
	  item.classList.toggle('active', isActive);
	  const label = item.querySelector('.timeline--label');
	  if (label) {
		label.classList.toggle('active', isActive);
	  }
	});
  
	if (isMobile()) {
	  centerActiveLabel();
	}
}